<template>
  <div id='contactPre' class="cover-container" >
  </div>

  <div class="cover-container"  style='background-color:#edf0f5'>

    <div class="container mx-auto flex-column" style='background-color:#edf0f5'>
      <div class="row pt-3 pb-4">
        <!-- <div class='col-sm-12 text-center'>
          <h2 class="display-5">How To</h2>
        </div> -->
        <div class="col-sm-12 mx-3 mx-md-0 d-flex flex-md-row flex-column justify-content-center">
          <form @submit.prevent="showCaptcha">
            <div class="input-group mb-3">
              <input type="email" v-model="email" class="form-control" placeholder="Your email" aria-label="Recipient's Email" aria-describedby="basic-addon2" @blur="handleEmailValidate" @keydown.enter="showCaptcha">
              <button class="input-group-text" id="basic-addon2">Send</button>
              <span id="emailErrorMessage" v-if="emailError">{{ emailError }}</span>
              <span id="emailErrorMessage" v-if="captchaError">{{ captchaError }}</span>
              
              
            </div>
          </form>
          <div class="mb-3 text-center p-2 ml-2 mr-2">
            <span class='badge badge secondary'>OR</span>
          </div>
          <div class="mb-3 mr-2" style="min-width: 40%;">
            <a target="_blank" :href="`https://api.whatsapp.com/send?phone=${whatsapp}&text=Hello,+got+your+whatsapp+from+goong2000+web`" class="btn btn-block btn-success"><i class='fa fa-whatsapp'></i> Whatsapp</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-show="isModalShow" id="modalBlank" >
    <div class="modal-dialog-custom">

      <!--Content-->
      <div class="modal-content-custom">
        <div class="modal-body-custom">
          <div v-if="isModalInfo" v-html="modalContent"></div>
          <div v-show="isModalCaptcha">
              <div id='captchaContainer'>
                <h3>Hooman ?</h3>
                <strong>CAPTCHA : </strong>
                <span v-show="isCounterLoading">loading...</span>
                <span v-show="!isCounterLoading">
                  <span id='number1'>{{ number1 }}</span> <span id='eq_symbol' v-html='eq_symbol'></span> <span id='number2'>{{ number2 }}</span> = 
                  <input ref="captchaResult" style="text-align:center" id="captchaResult" @input="handleCaptcha">
                  <span style="cursor:pointer" class="ml-2" @click="generateCaptcha"><i class="fa fa-refresh"></i></span>
                </span>
              </div>
          </div>
        </div>
        <div class="modal-footer-custom">
          <button v-if="!isPending" type="button" class="btn btn-outline-primary btn-rounded btn-md mr-2" data-dismiss="modal" @click="isModalShow = false">Close</button>
          <button v-if="isPending" class="btn btn-outline-primary btn-rounded btn-md mr-2" style="background:#ccc" disabled>Sending...</button>
          <button type="button" v-if="isModalCaptcha && isCaptchaValid" class="btn btn-primary btn-rounded btn-md" @click="handleSubmit">SEND</button>
          <button type="button" v-if="isModalCaptcha && !isCaptchaValid" style="cursor:not-allowed" class="btn btn-primary btn-rounded btn-md" disabled>SEND</button>
        </div>
      </div>
      <!--/.Content-->
    </div>
  </div>

</template>

<script>
import useCollection from '@/composables/useCollection'
import { ref } from '@vue/reactivity';
import {projectFunctions, timestamp} from '@/firebase/config'
import getCollection from '@/composables/getCollection'
import ModalBlank from '@/components/ModalBlank.vue'

export default {
  name: 'ContactBar',
  components: {
    ModalBlank
  },
  props:['setting'],
  setup(props) {

        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = today.getFullYear();
        const tanggal = `${yyyy}-${mm}-${dd}`
        const isModalShow = ref(false)
        const isModalInfo = ref(false)
        const isModalCaptcha = ref(false)
        const isCounterLoading = ref(false)
        const modalContent = ref(`<h3>Email is busy</h3>We're really sorry for the inconvinience, <br> 
                but right now our mail system is busy, <br>
                Please contact us via whatsapp insted `)
    
        const { addDoc } = useCollection('visitor');
        const {documents:emailCounter} = getCollection('emailVisitorCounter',['tanggal','==',tanggal])
        const email = ref('');
        const emailError = ref(null)
        const captchaError = ref(null)
        const isPending = ref(false)
        const number1 = ref(null)
        const number2 = ref(null)
        const captchaResult = ref(null)
        let eq_idx = 0
        const eq_symbol = ref('')
        const isCaptchaValid = ref(false)
        const evc_id = ref(0)
        const counter  = ref(0)
        const whatsapp = ref(props.setting.whatsapp)

        const noWA = props.setting.noWA
        console.log(props.setting.whatsapp)

        const generateCaptcha = async() => {
          number1.value = Math.floor(Math.random() * 4)
          number2.value = Math.floor(Math.random() * 4)
          eq_idx = Math.floor(Math.random() * 2)
          
          if (eq_idx) {
            eq_symbol.value = "<i class='fa fa-plus'></i>";
          }else{
            eq_symbol.value = "<i class='fa fa-minus'></i>";
          }

          if (evc_id.value === 0) {
            if (emailCounter.value) {
              emailCounter.value.forEach(item => {
                evc_id.value = item.id
              });
            }
          }

          isCounterLoading.value = true
          const cekEmailCounter = projectFunctions.httpsCallable('cekEmailCounter')
          
          const counterData = await cekEmailCounter({id: evc_id.value, tanggal:tanggal, waktu:timestamp()}).then(result => {
            return result.data
          })

          counter.value = counterData.counter
          evc_id.value = counterData.counterId
          isCounterLoading.value = false
          captchaResult.value.focus()
          
        }

        const showCaptcha = async () => {
          isModalCaptcha.value = true
          isModalInfo.value = false
          
          generateCaptcha()
          
          // console.log('y', counterData.counterId, counterData.result)

          if (counter.value <= 98){
          }else{
            isModalCaptcha.value = false
            isModalInfo.value = true
            modalContent.value = `<h3>Email is busy</h3>We're really sorry for the inconvinience, <br> 
                but right now our mail system is busy, <br>
                Please contact us via whatsapp insted `
          }
          isModalShow.value = true

        }

        const handleSubmit = async() => {

          isModalCaptcha.value = false

          if (!emailError.value && email.value != '' && isCaptchaValid.value == true) {
            isPending.value = true
            counter.value++;
            await addDoc({
                email:email.value,
                messages: "This is auto-generated email",
                createdAt: timestamp(),
                tanggal: tanggal,
                counter: counter.value,
                counterId: evc_id.value
            })

            modalContent.value = `<h3>Hi,</h3>Thank you for reaching us, <br> 
              Our team will contact you soon, <br> Greetings!! `

            // isShowModal.value = false
            emailError.value = null
            captchaError.value = null
            captchaResult.value = null
            isCaptchaValid.value = false
            email.value = ''
            number1.value = ''
            number2.value = ''
            eq_symbol.value = ''
            isPending.value = false

            // console.log('ya');
          }else if(email.value == ''){
            emailError.value = 'Please enter a valid email address'
          }else if (!isCaptchaValid.value) {
            captchaError.value = 'Please fill captcha'
          }

          isModalInfo.value = true

        }

        const handleEmailValidate = () => {
          let ts = email.value
          // console.log(ts.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/))
          if (ts.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)){
            emailError.value = null
          } else{
            captchaError.value = 'Please enter a valid email address'
          }
        }

        const handleCaptcha = () => {
          let rs = parseInt(number1.value) + parseInt(number2.value)
          if (eq_idx) {
            rs = parseInt(number1.value) + parseInt(number2.value)
          }else{
            rs = parseInt(number1.value) - parseInt(number2.value)
          }

          if (rs == captchaResult.value.value) {
            isCaptchaValid.value = true
          }else{
            isCaptchaValid.value = false
          }
        }

        return {handleSubmit, handleEmailValidate, emailError, email, 
            isPending, number1, number2, eq_symbol, captchaError,
            captchaResult, isCaptchaValid, handleCaptcha, modalContent,
            isModalShow, isModalInfo, isModalCaptcha, showCaptcha,
            generateCaptcha, isCounterLoading, whatsapp}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#contactPre{
  position: relative; 
  height:80px;
  background-image:url('../assets/custom_icon/banner-bottom-1.png'); 
  background-repeat: no-repeat; 
  background-position:center center; 
  background-size:cover;
}

#emailErrorMessage{
  position: absolute;
  bottom: -10px;
  background: wheat;
  font-size: 12px;
  padding: 0px 10px;
}

form{
  width: 100%;
}


#captchaResult{
  width: 50px;
}

#eq_symbol{
  font-size: 10px;
}

/* =============modal===================== */
#modalBlank{
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
  padding-top:150px;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
}

.modal-dialog-custom{
  width: 400px;
  margin: auto;
  background: wheat;
  padding: 20px;
}

.modal-footer-custom{
  text-align: right;
  margin: 30px 0 0px 0;
}
</style>
